import { request } from '@/utils/api/request';

import { ENDPOINT } from '@/constants/api';
import { ETSY } from '@/constants/channels';

export const listings = {
  getCategoryIds({ channel, db, payload, shopId, signal }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: channel === ETSY
        ? `/${channel}/shops/${shopId}/listings/taxonomy_ids`
        : `/${channel}/shops/${shopId}/listings/category_ids`,
    });
  },
  getFilters({ channel, db, filters, shopId, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V2,
      params: { ...filters, db },
      signal,
      url: `/${channel}/shops/${shopId}/listings/filters`,
    });
  },
  getListings({ channel, db, filters, shopId, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V2,
      params: { ...filters, db },
      signal,
      url: `/${channel}/shops/${shopId}/listings`,
    });
  },
  getListingIds({ channel, db, payload, shopId, signal }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      payload,
      signal,
      url: `/${channel}/shops/${shopId}/listings/ids`,
    });
  },
  getStatuses({ channel, db, shopId, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V2,
      params: { db },
      signal,
      url: `/${channel}/shops/${shopId}/listings/status/count`,
    });
  },
};
